import { Fragment } from 'react';
import { TagWrapper } from '@/home/HeroCardsReturnUser/LinkCards/VDPLinks/StatusTag';
import { addNewestInventorySortToCvnaId } from '@/home/RecentSearches/RecentSearches';
import { RecentSearch } from '~/contracts/home';
import Chevron from '~/icons/Chevron';
import { nativeSrpPayload } from '~/native/common/utils';
import { CardContainer } from '../LinkCard.styles';

type OwnProps = {
  links: RecentSearch[];
};

export default function RecentSearchLink({ links }: OwnProps) {
  return links.map((link, index) => {
    const isLastItem = index === links.length - 1;
    const {
      totalNewVehicles = 0,
      totalMatchingVehicles = 0,
      cvnaId,
      display: { name },
      savedSearch
    } = link;

    const savedSearchName = savedSearch?.name ?? name;

    return (
      <Fragment key={cvnaId}>
        <CardContainer
          hasFullSetOfCards={links.length === 4}
          data-qa="recent-search-links"
        >
          <a
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify({
              description: 'Search Card',
              type: 'recent',
              item: 'search'
            })}
            data-native-payload={nativeSrpPayload}
            href={`/cars/filters?cvnaid=${addNewestInventorySortToCvnaId(
              cvnaId
            )}`}
            className="group grid grid-cols-[1fr_20px] items-center gap-xl text-blue-6"
          >
            <div className="flex flex-col items-start gap-md">
              <div className="line-clamp-2 tl-header-s" title={savedSearchName}>
                {savedSearchName}
              </div>
              {(totalMatchingVehicles >= 0 || totalNewVehicles > 0) && (
                <div className="flex gap-8">
                  {totalMatchingVehicles >= 0 && (
                    <p
                      className="tl-body-s"
                      data-qa="saved-search-results-count"
                    >
                      {totalMatchingVehicles.toLocaleString()} results
                    </p>
                  )}
                  {totalNewVehicles > 0 ? (
                    <TagWrapper className="bg-marketplace-purple">
                      {totalNewVehicles} New
                    </TagWrapper>
                  ) : null}
                </div>
              )}
            </div>
            <div className="flex-shrink-0">
              <Chevron className="group-hover:stroke-blue-3" />
            </div>
          </a>
        </CardContainer>
        {!isLastItem && <div className="border-t border-grey-2" />}
      </Fragment>
    );
  });
}
